export default {
  P1: "#B2208B",
  P2: "#F8E8F4",
  S1: "#8F176F",
  S2: "#F9EAF5",
  BG1: "#FFFFFF",
  BG2: "#F7F5F7",
  BG3: "#AAB2BD",
  G1: "#212121",
  G2: "#757575",
  G3: "#9E9E9E",
  G4: "#E0E0E0",
  G5: "#4D4D4D",
  gradientStart: "#B2208B",
  gradientEnd: "#8F176F",
};